import React from "react";
import { OBJECT_TYPE } from "common/constants";
import { Label } from "../AddressPanel/PropertyOverview/__styles__";
import {
  Table,
  TableBody,
  TableCell,
  TableCellContainer,
  TableHeader,
  TableRow,
} from "../Common/__styles__/StripedTable";
import { ObjectCarousel } from "../Common/Carousel/Carousel";
import { ContentWrapper } from "./__styles__/ObjectInformationPanel";
import { ObjectInfoPanelTabProps } from "./types";

export const OVERVIEW_LABEL = "Object properties";

const Overview = ({ geometry, customMap }: ObjectInfoPanelTabProps) => {
  const order =
    customMap.config.uiSchema["ui:order"] ??
    Object.keys(geometry.additionalFields);

  return (
    <ContentWrapper>
      <ObjectCarousel
        objectId={geometry.id}
        objectType={OBJECT_TYPE.CUSTOM_MAP_GEOMETRY}
        label={geometry.label}
        coverImageDocumentUploadId={geometry.coverImageDocumentUploadId ?? null}
      />
      <Table spacing="negative">
        <TableHeader>
          <TableRow header>
            <TableCell>{OVERVIEW_LABEL}</TableCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {order.map(key => (
            <TableRow header={false} key={key}>
              <TableCell containsTooltip>
                <TableCellContainer>
                  <Label size="narrow">{key}</Label>
                </TableCellContainer>
              </TableCell>
              <TableCell style={{ whiteSpace: "normal" }}>
                <span>{geometry.additionalFields[key]}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ContentWrapper>
  );
};

export default Overview;
